function ExpandOutOfStockCodesModalController(
    $scope,
    $uibModalInstance,
    items
) {
    this.modalInstance = $uibModalInstance;

    $scope.items = items;

    $scope.close = () => {
        this.modalInstance.close();
    }
}

angular.module('dashboard')
    .controller('ExpandOutOfStockCodesModalController',
        [
            '$scope',
            '$uibModalInstance',
            'items',
            ExpandOutOfStockCodesModalController
        ])


